import Producto from '../Producto/Producto';
import './Productos.css';
import { useAuth } from '../../context/AuthContext';
import { Compartir } from '../Compartir/Compartir';
import { searchClient, routing } from '../../firebase/algolia';
import { InstantSearch, SearchBox, Hits, RefinementList, Pagination, useInstantSearch, RangeInput, ClearRefinements, SortBy, Stats, HierarchicalMenu } from 'react-instantsearch';
import { upperFL } from '../../utils/utils'
import React, {useState, useEffect}from 'react'
import { CustomRangeInput } from './CustomRangeInput/CustomRangeInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShirt, faCircleInfo } from '@fortawesome/free-solid-svg-icons'
import { Helmet } from 'react-helmet';


export const Productos = () => { 
  
    const { user, premium, planName } = useAuth();
    const [showFilters, setShowFilters] = useState(false);
    const usarIA = ['Plan Explora+', 'Plan Radar+'].includes(planName);


    function formatUrlParameters(url) {
      const params = new URLSearchParams(url.search);
  
      const query = params.getAll('query').join(', ');
      const categories = params.getAll('hierarchicalCategories.lvl0').join(' ');
      const sex = params.getAll('sex[0]').join(', ');
      const web = params.getAll('web[0]').join(', ');
      const size = params.getAll('size[0]').join(', ');
      const condition = params.getAll('condition[0]').join(', ');
      const color = params.getAll('color[0]').join(', ');
      const city = params.getAll('city[0]').join(', ');
      const brand = params.getAll('brand[0]').join(', ');
  
      // Separar los niveles de categorías por comas  
      let title = '';
      if (query !== '') {
          title += `${query} `;
      } 
      if (categories !== '') {
          title += `${categories}`;
      } else {
          if (query === "") {
              title += 'Ropa de segunda mano';
          }
      }
      if (sex !== '') {
          title += ` de ${sex}`;
      }
      if (size !== '') {
          title += `, talla: ${size}`;
      }
      if (condition !== '') {
          title += `, ${condition}`;
      }
      if (color !== '') {
          title += `, color: ${color}`;
      }
      if (city !== '') {
          title += ` en ${city}`;
      }
      if (web !== '') {
          title += `, ${web}`;
      }
      if (brand !== '') {
          title += `, marca: ${brand}`;
      }
  
      return upperFL(title || 'Ropa de segunda mano');
  }
  

  const currentUrl = window.location.href;
  const exampleUrl = new URL(currentUrl);
  const formattedResult = formatUrlParameters(exampleUrl);
  const title = formattedResult;

  // No results
  function NoResultsBoundary({ children, fallback }) {
    const { results } = useInstantSearch();

    if (!results.__isArtificial && results.nbHits === 0) {
      return (
        <>
          {fallback}
          <div hidden>{children}</div>
        </>
      );
    }

    return children;
  }

  function NoResults() {
    const { indexUiState } = useInstantSearch();

    return (
      <div>
        <p>
          No results for <q>{indexUiState.query}</q>.
        </p>
      </div>
    );
  }

  useEffect(() => {
    if (showFilters) {
      document.body.style.overflow = 'hidden'; // Bloquea el desplazamiento del fondo
    } else {
      document.body.style.overflow = ''; // Restaura el desplazamiento
    }
    return () => {
      document.body.style.overflow = ''; // Limpia el efecto al desmontar
    };
  }, [showFilters]);

  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  // Borrar palabras
  useEffect(() => {
    const palabrasProhibidas = [
      'desconocido', 
      'otro',
      'sin especificar',
      'desconocida',
      'color',
      'local',
      'vintage',
      'sin marca',
      'ubicacion',
      'es',
      'spain',
      'one size',
      'talla única'
    ];
  
    const hideItems = () => {
      const items = document.querySelectorAll('.ais-RefinementList-item');
      items.forEach(item => {
        const labelText = item.querySelector('.ais-RefinementList-labelText');
        if (labelText) {
          const texto = labelText.textContent.trim().toLowerCase();
          if (palabrasProhibidas.some(palabra => texto.includes(palabra.toLowerCase()))) {
            item.style.display = 'none';
          }
        }
      });
    };
  
    // Ejecutar inmediatamente y luego cada 500ms
    hideItems();
    const interval = setInterval(hideItems, 500);
    
    return () => clearInterval(interval);
  }, []);

  const hitComponent = premium 
  ? ({ hit }) => <Producto hit={hit} premium={premium} planName={planName} user={user} />
  : ({ hit }) => <Producto hit={hit} premium={premium} planName={planName} user={user}/>;

const containerPText = `Aquí tienes ${title}. Explora nuestro catálogo exclusivo de prendas vintage de segunda mano, cuidadosamente seleccionadas para ti. Encuentra inspiración en una amplia variedad de estilos y épocas. Navega por nuestra colección y encuentra piezas únicas que te transportarán a otras décadas. Descubre las mejores ofertas a través de nuestras alertas y sumérgete en la moda retro con nosotros.`;

const MetaRobots = () => {
  const { results } = useInstantSearch();

  // Solo añadimos noindex si no hay resultados reales
  if (!results.__isArtificial && results.nbHits === 0) {
    return (
      <Helmet>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
    );
  }

  return null;
};

return (
  <div>
    <InstantSearch indexName="productos_erastro" searchClient={searchClient} routing={routing}>
      <MetaRobots />
      <div className="search-container">
        <SearchBox placeholder={"Buscar producto"} className="buscador-principal" />
      </div>

      <div className="container">
        <button className="toggle-filters-button" onClick={toggleFilters}>
          {showFilters ? 'Ocultar filtros' : 'Mostrar filtros'}
        </button>

        {showFilters && <div className="overlay" onClick={toggleFilters}></div>}

        <div className={`filter-container ${showFilters ? 'visible' : ''}`}>
          <button className="close-filters-button" onClick={toggleFilters}>✕</button>
          <div className="filter">
            <ClearRefinements translations={{ resetButtonText: 'Borrar filtros' }} />
            <h3>Sexo</h3>
            <RefinementList attribute="sex" />
            <h3>Precio</h3>
            <RangeInput attribute="price" />
            
            {user && usarIA && (
              <>
                <h3>
                  Euros de ahorro
                  <span className="info-container">
                    <span className="info-icon">
                      <FontAwesomeIcon icon={faCircleInfo} />
                    </span>
                    <div className="info-tooltip">
                      Filtra productos según el ahorro en euros que calcula nuestra IA comparando su precio con el valor habitual.  
                      Por ejemplo: si pones "-5" en valor maximo, verás solo productos que te hacen ahorrar al menos 5 euros.
                    </div>

                  </span>
                </h3>
                <CustomRangeInput attribute="price_difference" />

                <h3>
                  % de ahorro
                  <span className="info-container">
                    <span className="info-icon">
                      <FontAwesomeIcon icon={faCircleInfo} />
                    </span>
                    <div className="info-tooltip">
                      Filtra productos según el porcentaje de ahorro que calcula nuestra IA comparando su precio con el valor habitual. Por ejemplo: si pones "-5" en valor maximo, verás solo productos que te hacen ahorrar al menos 5%.
                    </div>
                  </span>
                </h3>
                <CustomRangeInput attribute="percentage_price_difference" />
              </>
            )}

            <h3>Categorías</h3>
            <HierarchicalMenu
              limit={10}
              showMore={true}
              showMoreLimit={40}
              attributes={[
                "hierarchicalCategories.lvl0",
                "hierarchicalCategories.lvl1",
                "hierarchicalCategories.lvl2"
              ]}
            />
            <h3>Talla</h3>
            <RefinementList attribute="size" limit={7} showMore={true} searchable={true} />
            <h3>Estado</h3>
            <RefinementList attribute="condition" limit={5} />
            <h3>Color</h3>
            <RefinementList attribute="color" limit={7} showMore={true} searchable={true} />
            <h3>Marca</h3>
            <RefinementList attribute="brand" limit={8} showMore={true} searchable={true} />
            <h3>Ubicación</h3>
            <RefinementList attribute="city" limit={7} showMore={true} searchable={true} />
          </div>
        </div>

        <div className="productos">
          <NoResultsBoundary fallback={<NoResults />}>
            <h1>{title}</h1>
            <Compartir />    
            <div className="stats-sort">
                  <Stats />
                  <SortBy
                    items={[
                      { label: 'Relevantes', value: 'productos_erastro' },
                      { label: 'Precio (asc)', value: 'productos_price_asc' },
                      { label: 'Precio (desc)', value: 'productos_price_des' },
                    ]}
                  />
            </div>
            <Hits hitComponent={hitComponent} />
          </NoResultsBoundary>
        </div>
      </div>

      <div className="pagination-container">
        <Pagination className="pagination" totalPages={10} />
      </div>
    </InstantSearch>
    
    <p className='container-p'>{containerPText}</p>
  </div>
);
};


